import { ValidationTypes } from "@enums/validation-types";
import { DCUIContent } from "@iddataweb/idw-common-ui/types";

export const getValidationTypeInProgressLabel = (validationType: ValidationTypes, content: DCUIContent) => {
    switch (validationType) {
        case ValidationTypes.PORTRAIT_ORIENTATION_DETECTION:
            return content.validation.portraitDetectionLoadingText;
        case ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION:
            return content.validation.landscapeDetectionLoadingText;
        case ValidationTypes.GLARE_DETECTION:
            return content.acuant.validation.glareDetectionValidationHeader;
        case ValidationTypes.SHARPNESS_DETECTION:
            return content.acuant.validation.lowSharpnessDetectionValidationHeader;
        case ValidationTypes.LIVENESS_DETECTION:
            return content.acuant.validation.livenessDetectionValidationHeader;
        case ValidationTypes.GOOD_RESOLUTION_DETECTION:
            return content.acuant.validation.lowDPIDetectionValidationHeader;
        default:
            return "";
    }
};

export const getValidationTypeSubheading = (validationType: ValidationTypes, content: DCUIContent) => {
    switch (validationType) {
        case ValidationTypes.PORTRAIT_ORIENTATION_DETECTION:
            return content.validation.portraitDetectionSubheading;
        case ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION:
            return content.validation.landscapeDetectionSubheading;
        case ValidationTypes.GLARE_DETECTION:
            return content.acuant.validation.glareDetectionValidationHeader;
        case ValidationTypes.SHARPNESS_DETECTION:
            return content.acuant.validation.lowSharpnessDetectionValidationHeader;
        case ValidationTypes.LIVENESS_DETECTION:
            return content.acuant.validation.livenessDetectionValidationHeader;
        case ValidationTypes.GOOD_RESOLUTION_DETECTION:
            return content.acuant.validation.lowDPIDetectionValidationHeader;
        default:
            return "";
    }
};

export const getValidationTypeSuccessMessage = (validationType: ValidationTypes, content: DCUIContent) => {
    switch (validationType) {
        case ValidationTypes.PORTRAIT_ORIENTATION_DETECTION:
            return content.validation.portraitDetectionSuccessMessage;
        case ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION:
            return content.validation.landscapeDetectionSuccessMessage;
        case ValidationTypes.GLARE_DETECTION:
            return content.acuant.validation.validGlareMessage;
        case ValidationTypes.SHARPNESS_DETECTION:
            return content.acuant.validation.validSharpnessMessage;
        case ValidationTypes.LIVENESS_DETECTION:
            return content.acuant.validation.validLivenessDetectedMessage;
        case ValidationTypes.GOOD_RESOLUTION_DETECTION:
            return content.acuant.validation.validDPIMessage;
        default:
            return "";
    }
};

export const getValidationTypeErrorMessage = (validationType: ValidationTypes, content: DCUIContent) => {
    switch (validationType) {
        case ValidationTypes.PORTRAIT_ORIENTATION_DETECTION:
            return content.validation.portraitDetectionErrorMessage;
        case ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION:
            return content.validation.landscapeDetectionErrorMessage;
        case ValidationTypes.GLARE_DETECTION:
            return content.acuant.validation.invalidGlareMessage;
        case ValidationTypes.SHARPNESS_DETECTION:
            return content.acuant.validation.invalidSharpnessMessage;
        case ValidationTypes.LIVENESS_DETECTION:
            return content.acuant.validation.livenessNotFoundErrorMessage;
        case ValidationTypes.GOOD_RESOLUTION_DETECTION:
            return content.acuant.validation.invalidDPIMessage;
        default:
            return "";
    }
};
